export const setFieldsMethod = (
  form: any,
  name: string,
  value: string
): void => {
  form.setFieldsValue({ [name]: value });
};
